import React, { Fragment, useState } from 'react';
import urlJoin from 'url-join';
import queryString from 'query-string';
import delve from 'dlv';
import styled from 'styled-components';
import { compose } from 'recompose';
import { withApollo } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import { useLazyQuery } from 'apollo-3';

import { useConfig } from 'Context/ConfigContext';
import { useAllMyCoursesData } from 'Domain/MyCourseData';
import { Flex, Text, Box, ButtonFilled } from 'Components/Base';
import Loading from 'Components/Loading';
import { onlineCourseByCourseCode } from 'GraphQL/query/Product.query';
import { useGoToPurchase } from 'Domain/ExternalNavigation';

import { getStoreApolloClient } from '../../../GraphQL';
// import EnterClassroomErrorModal from '../EnterClassroomErrorModal';
import NoCourseModal from '../Components/NoCourseModal';
import EnterClassroomErrorModal from '../Components/EnterClassroomErrorModal';
import NoAccessibleCourseModal from '../Components/NoAccessibleCourseModal';

const storeApolloClient = getStoreApolloClient();

const ClassroomLoading = ({ client, history, i18n, t, location, ...props }) => {
  const courseCode = delve(props, ['match', 'params', 'courseCode'], null);
  const subsectionReferId = delve(props, ['match', 'params', 'subsectionReferId'], null);
  const { p: provider } = queryString.parse(location.search);
  const { onlineCourseDetailUrl } = useConfig();
  const [showNotFoundCourseModal, setShowNotFoundCourseModal] = useState(false);

  const [
    getOnlineCourseByCourseCode,
    {
      data: { sfFoProductGetOnlineCourseByCourseCode: onlineCoursesData } = {},
      loading,
      error: onlineCoursesError,
    },
  ] = useLazyQuery(onlineCourseByCourseCode, {
    variables: { courseCode },
    client: storeApolloClient,
  });

  const { enablePurchaseUrl, purchaseUrl } = useGoToPurchase(onlineCoursesData?.SKUCode);

  const onMyCourseCompleted = async () => {
    const landingCourse = myCoursesData.find(
      ({ courseInfo }) => courseInfo.courseCode === courseCode
    );
    if (landingCourse) {
      const {
        courseInfo: { id: courseId },
      } = landingCourse;
      if (subsectionReferId) {
        history.push(decodeURIComponent(`/classroom/${courseId}/subsection/${subsectionReferId}`));
      } else {
        history.push(decodeURIComponent(`/classroom/${courseId}`));
      }
    } else {
      if (enablePurchaseUrl) {
        getOnlineCourseByCourseCode();
      } else {
        setShowNotFoundCourseModal(true);
      }
    }
  };

  const { data: myCoursesData } = useAllMyCoursesData({
    variables: {
      language: i18n.language,
      status: 'ACTIVE',
    },
    onCompleted: onMyCourseCompleted,
  });

  if (onlineCoursesData) {
    const redirectToOCD = () => {
      window.location = urlJoin(onlineCourseDetailUrl, onlineCoursesData?.permalink);
    };

    const redirectToPurchase = () => {
      window.location = purchaseUrl;
    };

    const RedirectButton = (
      <Flex justifyContent={'center'}>
        {enablePurchaseUrl && (
          <Fragment>
            <ButtonFilled onClick={redirectToPurchase} mt={5}>
              {t('ERROR.ENTER_CLASSROOM.PURCHASE_BUTTON')}
            </ButtonFilled>
            <Box px={3} />
          </Fragment>
        )}
        <ButtonFilled color={'text'} onClick={redirectToOCD} mt={5}>
          {t('ERROR.ENTER_CLASSROOM.OCD_BUTTON')}
        </ButtonFilled>
      </Flex>
    );

    let subtitle = `${t('ERROR.ENTER_CLASSROOM.NO_COURSE_SUBTITLE')} ${onlineCoursesData.title}`;

    // in case mycousreville provider
    if (provider === 'mcv') {
      subtitle = `${t('ERROR.ENTER_CLASSROOM.NO_COURSE_SUBTITLE')} ${onlineCoursesData.title}
        ${t('ERROR.ENTER_CLASSROOM.MYCOURSEVILLE_SUBTITLE')}`;
    }

    return (
      <NoCourseModal
        isActive={true}
        description={subtitle}
        onPurchaseClick={enablePurchaseUrl && redirectToPurchase}
        onOCDClick={redirectToOCD}
        footer={RedirectButton}
      />
    );
  }

  if (onlineCoursesError) {
    return <EnterClassroomErrorModal isActive />;
  }

  if (showNotFoundCourseModal) {
    return <NoAccessibleCourseModal isActive />;
  }

  return (
    <Flex width={1} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} py={9}>
      <Loading width={100} height={100} />
      <Text mt={3}>{t('LOADING')}</Text>
    </Flex>
  );
};

export default compose(withApollo, withTranslation('classroom'))(ClassroomLoading);
